import {ThemeProvider} from './context/theme/theme'
import Homes from './Pages/home';
import { useEffect, useState } from "react";
import SnakeLoader from './components/loader/circleOrbiteLoader';


function App() {
 const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simule un chargement
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
      <ThemeProvider >
         <>
       
             <div>
      {isLoading ? (
        <SnakeLoader />
      ) : (
        <div> <Homes/></div>
      )}
    </div>
      
         </>
      </ThemeProvider>
  );
}

export default App;
